import React from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification, InputNumber } from 'antd';
import { uploadAdsModalImage } from '../../modules/Api';
import { END_POINT } from '../../constants/config';

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class HeaderForm extends React.Component {
    constructor() {
        super();
        this.state = {
            link: "",
            alt: "",
            desktop_image: null,
            mobile_image: null,
            status : 0,
        }
    }

    componentDidMount() {
        this.setState({
            link: "",
            alt: "",
            desktop_image: null,
            mobile_image: null,
            status : 0,
        })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.initialData.desktop_image && this.state.desktop_image === null) {
            this.setState({ desktop_image: nextProps.initialData.desktop_image });
        }
        if (nextProps.initialData.mobile_image && this.state.mobile_image === null) {
            this.setState({ mobile_image: nextProps.initialData.mobile_image });
        }
        if (nextProps.initialData.link && this.state.link === "") {
            this.setState({ link: nextProps.initialData.link });
        }
        if (nextProps.initialData.alt && this.state.alt === "") {
            this.setState({ alt: nextProps.initialData.alt });
        }
        if (nextProps.initialData.status && this.state.status === "") {
            this.setState({ status: nextProps.initialData.status });
        }
    }
    handleSubmit = e => {

        e.preventDefault();
        if (this.submittedAt > Date.now() - 500) {
            return;
        }
        this.submittedAt = Date.now();

        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(Object.assign({}, fieldsValue, {
                mobile_image: this.state.mobile_image,
                desktop_image: this.state.desktop_image,
            }));

        })
    }



    render() {
        var mobile_img = ""
        if (this.state.mobile_image != null) {
            mobile_img = <img src={`${this.state.mobile_image.includes('http') ? this.state.mobile_image : END_POINT + this.state.mobile_image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />

        } else if (this.props.initialData.mobile_image != null) {
            mobile_img = <img src={`${this.props.initialData.mobile_image.includes('http') ? this.props.initialData.mobile_image : END_POINT + this.props.initialData.mobile_image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />
        }
        var desktop_img = ""
        if (this.state.desktop_image != null) {
            desktop_img = <img src={`${this.state.desktop_image.includes('http') ? this.state.desktop_image : END_POINT + this.state.desktop_image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />

        } else if (this.props.initialData.desktop_image != null) {

            desktop_img = <img src={`${this.props.initialData.desktop_image.includes('http') ? this.props.initialData.desktop_image : END_POINT + this.props.initialData.desktop_image}`}
                style={{ width: '150px', height: '50px', margin: '10px' }}
                alt="modal"
            />
        }
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={9} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="عکس بنر دسکتاپ"
                                extra="	728 × 90 px  اندازه پیشنهادی "
                                colon={false}>
                                {getFieldDecorator('desktop_image', {
                                    initialValue: this.props.initialData.desktop_image ? this.props.initialData.desktop_image : null,

                                    valuePropName: 'fileListImage',
                                    getValueFromEvent: this.normFileImage,
                                })(
                                    <Upload
                                        name="desktop_image"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadAdsModalImage(f, (src) => { this.setState({ desktop_image: src }) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {desktop_img}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"لینک"}
                                colon={true} >
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link ? this.props.initialData.link : null,
                                    rules: [{
                                        required: true,
                                        message: 'لینک بنر: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                    <Row>
                        <Col span={9} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="عکس بنر موبایل"
                                extra="728 × 90 px اندازه پیشنهادی "
                                colon={false}>
                                {getFieldDecorator('mobile_image', {
                                    initialValue: this.props.initialData.mobile_image ? this.props.initialData.mobile_image : null,

                                    valuePropName: 'fileListImage',
                                    getValueFromEvent: this.normFileImage,
                                })(
                                    <Upload
                                        name="mobile_image"
                                        action=""
                                        customRequest={() => { }}
                                        onChange={f => { uploadAdsModalImage(f, (src) => { this.setState({ mobile_image: src }) }) }}
                                        listType="picture"
                                        showUploadList={false}>
                                        <Button>
                                            <Icon type="upload" /> انتخاب فایل
                                        </Button>
                                        <br />
                                        {mobile_img}
                                    </Upload>
                                )}
                            </FormItem>
                        </Col>

                        <Col span={11} offset={1}>


                            <FormItem
                                {...formItemLayout}
                                label={"تگ آلت"}
                                colon={true} >
                                {getFieldDecorator('alt', {
                                    initialValue: this.props.initialData.alt ? this.props.initialData.alt : null,
                                    rules: [{
                                        required: true,
                                        message: 'تگ آلت: ',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                        </Col>


                    </Row>
                    <Row>
                        <Col span={6} offset={16}>
                        <FormItem
                                {...formItemLayout}
                                label="وضعیت"
                                colon={false}>
                                {getFieldDecorator('status', {
                                    initialValue: this.props.initialData.status ? this.props.initialData.status : 0,
                                    rules: [],
                                })(
                                    <Select placeholder="وضعیت تبلیغ" style={{width: '200px'}}>
                                        <Select.Option value="0">غیرفعال</Select.Option>
                                        <Select.Option value="1">فعال</Select.Option>
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                        
                    </Row>

                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                        </div>
                    </FormItem>
                </Form>
            </div>
        )
    }
}
HeaderForm.defaultValue = {
    initialData: {}
}

export default Form.create()(HeaderForm);



// WEBPACK FOOTER //
// ./src/containers/Header/form.js